/* eslint-disable @typescript-eslint/no-unused-vars */
// src/components/TrialsCard.tsx
import React from 'react';
import { Card, CardContent } from '@mui/material';
import { Link } from 'react-router-dom';
import TruncatedTypography from '../TruncatedTypography';
import { Trial } from '../../types';
import './TrialsCard.css';
import { useTranslation } from 'react-i18next';
import { formatTreatment } from '../../utils';

interface TrialsCardProps {
  trial: Trial;
  getLocationsString: (trial: Trial) => string;
  hideLocation?: boolean;
}

const TrialsCard: React.FC<TrialsCardProps> = ({ trial, getLocationsString, hideLocation }) => {
  const { t } = useTranslation();

  return (
    <Link to={`/trials/${trial.nctId}`} className="trials-card">
      <Card className="trials-card">
        <CardContent className="trials-card__content">
          <div className="trials-card__block">
            <TruncatedTypography
              variant="h6"
              label=""
              text={trial.briefTitle || t('untitledTrial')}
              maxLength={75}
              lineHeight={1.2}
              className="trials-card__title"
            />
          </div>
          <div className="trials-card__block">
            <TruncatedTypography
              variant="body2"
              label={`${t('organSystem')}:`}
              text={trial.organSystem.join(', ')}
              maxLength={50}
              className="trials-card__detail"
            />
          </div>
          <div className="trials-card__block">
            <TruncatedTypography
              variant="body2"
              label={`${t('conditions')}:`}
              text={trial.conditions.join(', ')}
              maxLength={80}
              className="trials-card__detail"
            />
          </div>
          <div className="trials-card__block">
            {!hideLocation && (
              <TruncatedTypography
                variant="body2"
                label={`${t('locations')}:`}
                text={getLocationsString(trial)}
                maxLength={60}
                className="trials-card__detail"
              />
            )}
          </div>
          <div className="trials-card__block">
          <TruncatedTypography
            variant="body2"
            label={`${t('biomarker')}:`}
            text={trial.biomarker || t('unknown')}
            maxLength={60}
            className="trials-card__detail"
          />
          </div>
          <TruncatedTypography
            variant="body2"
            label={`${t('treatment')}:`}
            text={formatTreatment(trial.treatment)}
            maxLength={60}
            className="trials-card__detail"
          />
        </CardContent>
      </Card>
    </Link>
  );
};

export default TrialsCard;
